import { render, staticRenderFns } from "./RegionGroupMemberItem.vue?vue&type=template&id=07311537&scoped=true"
import script from "./RegionGroupMemberItem.vue?vue&type=script&lang=js"
export * from "./RegionGroupMemberItem.vue?vue&type=script&lang=js"
import style0 from "./RegionGroupMemberItem.vue?vue&type=style&index=0&id=07311537&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07311537",
  null
  
)

export default component.exports